import { render, staticRenderFns } from "./RecentlyUsePlace.vue?vue&type=template&id=4ab0bb70&scoped=true&"
import script from "./RecentlyUsePlace.vue?vue&type=script&lang=js&"
export * from "./RecentlyUsePlace.vue?vue&type=script&lang=js&"
import style0 from "./RecentlyUsePlace.vue?vue&type=style&index=0&id=4ab0bb70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab0bb70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VCard,VCardTitle,VChip,VChipGroup,VCol,VRow,VSlideItem})
